import { getFromLocalStorage } from 'widget/actions';

const getUtm = () => {
  const utm = getFromLocalStorage<Record<string, string>>('whatcrmWidgetUtm');
  if (!utm || typeof utm != 'object') return {};

  return utm;
};

export default getUtm;
